import React, { useMemo, useState, useEffect } from 'react';
import './style.scss';

export const Filter = ({ dataCategory, setGetParam, onClearList }) => {

    const [dtaFilter, setDataFilter] = useState({
        orderBy:    'published_at',
        categories: 'all',
    });

    useEffect(() => {

        const arrForFetch = [];

        let strUrlFetch = '';

        for (const key in dtaFilter) {
            if ({}.hasOwnProperty.call(dtaFilter, key)) {
                if (dtaFilter[key] && dtaFilter[key] !== 'all') {
                    arrForFetch.push(`${key}=${dtaFilter[key]}`);
                }
            }
        }

        if (arrForFetch.length) {
            strUrlFetch = arrForFetch.join('&');
        }
        //console.log('strUrlFetch-----', strUrlFetch);
        onClearList();
        setGetParam(strUrlFetch);

    }, [dtaFilter, setGetParam]);

    const renderOption = useMemo(() => {
        const keys = Object.keys(dataCategory);
        const options = [];

        options.push(<option key = 'all' value = 'all'>Всі рубрики</option>);
        keys.forEach((key, ind) => {
            options.push(<option key = { key } value = { key }>{ dataCategory[key] }</option>);
        });

        return options;
    }, [dataCategory]);

    const onChangeFilter = (event) => {
        const target = event.target;
        const copydtaFilter = { ...dtaFilter };

        copydtaFilter[target.name] = target.value;

        setDataFilter(copydtaFilter);
    };

    return (
        <div className = 'filter'>
            <form className = 'filter__form'>
                <div className = 'filter__group filter__group--pd'>

                    <label className = { `filter__field ${dtaFilter.orderBy === 'like_count' ? 'filter__field--active' : ''}` }>
                        Популярне
                        <input
                            className = 'filter__input'
                            name = 'orderBy'
                            type = 'radio'
                            value = 'like_count' onChange = { onChangeFilter }
                        />
                    </label>
                    <label className = { `filter__field ${dtaFilter.orderBy === 'published_at' ? 'filter__field--active' : ''}` }>
                        Нове
                        <input
                            className = 'filter__input'
                            name = 'orderBy'
                            type = 'radio'
                            value = 'published_at'
                            onChange = { onChangeFilter }
                        />
                    </label>
                </div>
                <div className = 'filter__group filter__group-select'>
                    <select className = 'filter__field' name = 'categories' onChange = { onChangeFilter }>
                        { renderOption }
                    </select>
                    <i className = 'icon icon-arrow-bottom' />
                </div>
            </form>
        </div>
    );
};
